import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ['userChatId']

  connect() {
    if (window.Telegram?.WebApp) {
      const webApp = window.Telegram.WebApp
      const user = webApp.initDataUnsafe.user;

      webApp.ready()
      webApp.expand()

      // Show query params in a popup for debug purposes
      // const params = new URLSearchParams(window.location.search);
      // if ([...params].length > 0) {
      //   const paramString = [...params.entries()].map(([k, v]) => `${k}=${v}`).join('\n');
      //   webApp.showPopup({
      //     title: 'Query Params',
      //     message: paramString,
      //     buttons: [{ type: 'close' }]
      //   });
      // }

      // if (webApp.initDataUnsafe.start_param) {
      //   webApp.showPopup({
      //     title: 'start_param',
      //     message: webApp.initDataUnsafe.start_param,
      //     buttons: [{ type: 'close' }]
      //   })
      // }

      if (window.location.search.includes('bid_created=true')) {
        webApp.showPopup({
          title: 'Заявка отправлена',
          message: 'Стартовали поиск подходящих исполнителей для вашего запроса.',
          buttons: [{ type: 'close' }]
        }, (buttonId) => {
          webApp.close()
        })
      }

      // Initialize back button
      this.setBackButton(webApp)
      this.setCssColors(webApp)

      if (this.hasUserChatIdTarget && user) {
        this.userChatIdTarget.value = user.id
      }
    }
  }

  setCssColors(webApp) {
    if (webApp.backgroundColor) {
      document.documentElement.style.setProperty('--tg-theme-bg-color', webApp.backgroundColor)
    }
    if (webApp.textColor) {
      document.documentElement.style.setProperty('--tg-theme-text-color', webApp.textColor)
    }
    if (webApp.hintColor) {
      document.documentElement.style.setProperty('--tg-theme-hint-color', webApp.hintColor)
    }
    if (webApp.linkColor) {
      document.documentElement.style.setProperty('--tg-theme-link-color', webApp.linkColor)
    }
    if (webApp.buttonColor) {
      document.documentElement.style.setProperty('--tg-theme-button-color', webApp.buttonColor)
    }
    if (webApp.buttonTextColor) {
      document.documentElement.style.setProperty('--tg-theme-button-text-color', webApp.buttonTextColor)
    }
  }

  setBackButton(webApp) {
    const backButton = webApp.BackButton

    const updateBackButton = () => {
      const params = new URLSearchParams(window.location.search);
      // Show back button only if "s" param is present
      if (params.has('s')) {
        backButton.show();
      } else {
        backButton.hide();
      }
    }

    updateBackButton()
    backButton.onClick(() => { window.location.href = '/telegram_app' })
  }

}
